import { render } from "./DefaultBaseFormT.vue?vue&type=template&id=4e60d7a8"
import script from "./DefaultBaseFormT.vue?vue&type=script&lang=js"
export * from "./DefaultBaseFormT.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__